<template>
  <div class="section section_gray section_no-padding">
    <div class="hero">
      <div class="max-width">
        <div class="hero__grid">
          <div class="hero__block">
            <div class="hero__shopify">
              <img src="@/assets/imgs/shopify-partners.svg" alt="Official Shopify Partners badge">
            </div>
            <h1 class="hero__title">Alm<span class="o"><img src="@/assets/imgs/word-0.png" alt=""></span>st <br>P<span class="e"><img src="@/assets/imgs/word-e.png" alt=""></span>rfect <br>Themes</h1>
            <div class="hero__label fadeIn">
            <span>
                <em class="hero__label-ill1"><img src="@/assets/imgs/left-ill.svg" alt=""></em>
                <em class="hero__label-ill2"><img src="@/assets/imgs/right-ill.svg" alt=""></em>
                <strong>for Shopify</strong>
            </span>
            </div>
          </div>

          <div class="hero__pic">
            <div class="hero__slider">
              <div class="swiper js--hero-slider">
                <div class="swiper-wrapper">
                  <div class="swiper-slide"><img loading="lazy" srcset="@/assets/imgs/hero-slider-1.webp 1x, @/assets/imgs/hero-slider-1@2x.webp 2x" src="@/assets/imgs/hero-slider-1.webp"></div>
                  <div class="swiper-slide"><img loading="lazy" srcset="@/assets/imgs/hero-slider-2.webp 1x, @/assets/imgs/hero-slider-2@2x.webp 2x" src="@/assets/imgs/hero-slider-2.webp"></div>
                  <div class="swiper-slide"><img loading="lazy" srcset="@/assets/imgs/hero-slider-3.webp 1x, @/assets/imgs/hero-slider-3@2x.webp 2x" src="@/assets/imgs/hero-slider-3.webp"></div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .hero {
    position:relative;
    padding:10rem 0 7.125rem;
    overflow:hidden;

    @include xxl {
      padding-bottom:5rem;
    }

    @include lg {
      padding-bottom:6rem;
    }

    @include md {
      padding-top:8rem;
      padding-bottom:3rem;
    }

    @include xs {
      padding-top:7rem;
    }

    &__grid {
      display:flex;
      justify-content:space-between;
      gap:3rem;

      @include xxl {

      }

      @include lg {
        gap:2rem;
      }

      @include md {
        flex-direction:column;
        align-items:center;
      }
    }

    &__block {
      position:relative;
      z-index:2;
      max-width:800px;
      flex:auto;

      @include xxl {
        max-width:650px;
      }

      @include lg {
        max-width:600px;
      }

      @include md {
        text-align:center;
      }
    }

    &__shopify {
      display:flex;
      align-items:center;
      justify-content:center;
      gap:.5rem;
      margin:0 0 3.5rem;

      @include lg {
        margin:0 0 2rem;
      }

      @include xs {
        margin:0 0 1.5rem;

        img {
          height:2.5rem;
          width:auto;
        }
      }
    }

    &__title {
      text-align:center;
      font-family: var(--font-family);
      font-weight: 900;
      font-size: 9.688rem;
      line-height: .9;
      letter-spacing: -0.02em;
      text-transform: uppercase;

      @include xxl {
        font-size:7rem;
      }

      @include lg {
        font-size:5rem;
      }

      @include md {
        font-size:7rem;
      }

      @include xs {
        font-size:4.2rem;
      }

      span {
        display:inline-block;
        vertical-align:top;
        transform:translateY(-1px);

        img {
          width:auto;
          height:148px;

          @include xxl {
            height:100px;
          }

          @include lg {
            height:70px;
          }

          @include md {
            height:100px;
          }

          @include xs {
            height:60px;
          }
        }
      }
    }

    &__label {
      display:flex;
      justify-content:center;
      margin-top:1.5rem;

      &.fadeIn {
        opacity: 0;
        transform: scale(0.7);
        transition:0s;

        &_active {
          animation: bounceScaleHero 0.9s cubic-bezier(.34,1.56,.64,1) forwards;
        }
      }

      @keyframes bounceScaleHero {
        0% {
          opacity: 0;
          transform: scale(0.7);
        }
        70% {
          opacity: 1;
          transform: scale(1.05) rotate(-6deg);
        }
        85% {
          opacity: 1;
          transform: scale(0.95);
        }
        100% {
          opacity: 1;
          transform: scale(1) rotate(-3deg);;
        }
      }

      @include xs {
        margin-top:1rem;
      }

      &-ill1 {
        position:absolute;
        right:calc(100% - .5rem);
        bottom:calc(100% - 1rem);
        width:32px;
        height:24px;

        @include lg {
          width:20px;
          height:30px;
          right:calc(100% - .5rem);
          bottom:calc(100% - 1.5rem);

          img {
            width:100%;
          }
        }
      }

      &-ill2 {
        position:absolute;
        left:calc(100% - .5rem);
        top:calc(100% - 1rem);
        width:31px;
        height:29px;

        @include lg {
          width:20px;
          height:30px;
          left:calc(100% - .5rem);
          top:calc(100% - .5rem);

          img {
            width:100%;
          }
        }
      }
    }

    span {
      position:relative;

      strong {
        white-space: nowrap;
        font-family:var(--font-secondary);
        background:#fff;
        border-radius:90px;
        border:3px solid var(--color-main);
        height:68px;
        display:inline-flex;
        align-items:center;
        padding:0 1.25rem;
        letter-spacing: -0.02em;
        line-height:1;
        font-size:3.188rem;
        transition-delay:.2s;
        font-weight:400;
        z-index:2;
        margin-bottom:-.5rem;
        position:relative;

        @include lg {
          height:3rem;
          font-size:2.25rem;
          padding:0 1rem;
          border:2px solid var(--color-main);
        }

        @include xs {
          height:2.5rem;
          font-size:1.75rem;
          padding:0 1rem;
          border:1px solid var(--color-main);
        }
      }
    }

    &__pic {
      margin-top:2rem;
      margin-right:-2rem;
      flex:none;
      position:relative;
      width:47%;

      @include lg {
        margin-top:0;
        margin-right:0;
      }

      @include md {
        width:100%;
      }

      &:before {
        width:100%;
        position:absolute;
        left:0;
        top:0;
        background:#fedc2d;
        content:'';
        height:150%;
        border-radius:100vw 100vw 0 0;

        @include xxl {
          width:120%;
        }

        @include lg {
          width:103%;
        }

        @include md {
          top:10%;
        }
      }
    }

    &__slider {
      position:relative;
      z-index:2;
      padding-top:8rem;

      @include lg {
        padding-top:6rem;
      }

      .swiper {
        padding:3rem;
        margin:-3rem;
      }

      .swiper-slide {
        opacity: 0;
        transform: scale(0.96);
      }

      .swiper-slide-active {
        opacity: 1;
      }

      .swiper-slide-active img {
        animation: heroSlideBounce .7s cubic-bezier(.34,1.56,.64,1);
      }

      @keyframes heroSlideBounce {
        0% {
          transform: scale(0.96);
        }
        60% {
          transform: scale(1.1);
        }
        100% {
          transform: scale(1);
        }
      }

      img {
        filter:drop-shadow(0 0 30px rgba(127, 127, 127, 0.1));
      }

      .swiper-pagination {
        position:initial;
        margin-top:1rem;
      }

      .swiper-pagination-bullet {
        width: 26px;
        height: 26px;
        background: transparent;
        opacity: 1;
        position:relative;
        padding:5px 0 0 5px;
        margin:0 2px !important;

        @include xs {
          width:20px;
          height:20px;
        }

        span {
          background:#000;
          opacity:.1;
          border-radius:50%;
          transition:var(--transition);
          width:1rem;
          height:1rem;
          display:block;

          @include xs {
            width:10px;
            height:10px;
          }
        }

        &-active {
          span {
            opacity:1;
          }
        }
      }

      .bullet-progress {
        width: 26px;
        height: 26px;
        transform: rotate(-90deg);
        position:absolute;
        top:0;
        left:0;

        @include xs {
          width:20px;
          height:20px;
        }
      }

      .bullet-progress__bg {
        fill: none;
        stroke: rgba(0,0,0,0);
        stroke-width: 3;
      }

      .bullet-progress__circle {
        fill: none;
        stroke: #000;
        stroke-width: 3;
        transition: stroke-dashoffset 0.1s linear;
      }

    }
  }
</style>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  if (!window.Swiper) {
    const css = document.createElement('link')
    css.rel = 'stylesheet'
    css.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'
    document.head.appendChild(css)

    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'
    script.onload = initSwiper
    document.body.appendChild(script)
  } else {
    initSwiper()
  }

  function initSwiper() {
    const delay = 4000
    const radius = 16
    const circumference = 2 * Math.PI * radius

    const swiper = new window.Swiper('.js--hero-slider', {
      loop: true,
      speed: 800,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: delay,
        disableOnInteraction: false
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index, className) {
          return `
            <span class="${className}">
              <span></span>
              <svg class="bullet-progress" viewBox="0 0 36 36">
                <circle class="bullet-progress__bg" cx="18" cy="18" r="${radius}"></circle>
                <circle class="bullet-progress__circle" cx="18" cy="18" r="${radius}"></circle>
              </svg>
            </span>
          `
        }
      },
      on: {
        init(s) {
          const circles = s.pagination.el.querySelectorAll('.bullet-progress__circle')
          circles.forEach(c => {
            c.style.strokeDasharray = circumference
            c.style.strokeDashoffset = circumference
          })
          bounceActiveSlide(s)
        },

        slideChangeTransitionStart(s) {
          bounceActiveSlide(s)
        },

        autoplayTimeLeft(s, time, progress) {
          const bullets = s.pagination.el.querySelectorAll('.swiper-pagination-bullet')
          const activeIndex = s.realIndex

          bullets.forEach((b, i) => {
            const circle = b.querySelector('.bullet-progress__circle')
            if (!circle) return

            if (i === activeIndex) {
              circle.style.strokeDashoffset = circumference * progress
            } else {
              circle.style.strokeDashoffset = circumference
            }
          })
        }
      }
    })

    function bounceActiveSlide(swiperInstance) {
      swiperInstance.slides.forEach(slide => {
        slide.classList.remove('is-bounce')
      })

      const active = swiperInstance.slides[swiperInstance.activeIndex]
      if (active) {
        void active.offsetWidth
        active.classList.add('is-bounce')
      }
    }
  }
})
</script>
